import React from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { AreaType, RoomType } from "../../../controller/MasterController";
import "../../../styles/CustomModal.css";
import { Style } from "./style";
import { SelectAreaModalViewProps } from "./types";

const SelectAreaModalView = ({ props, hook }: SelectAreaModalViewProps) => {
  return (
    <Modal
      open={props.isVisible}
      onClose={hook.onCloseModal}
      center
      classNames={{
        overlay: "selectAreaModalOverlay",
        modal: "selectAreaModal",
      }}
      closeOnOverlayClick={true}
      showCloseIcon={
        hook.deviceArea &&
        hook.deviceArea.area_number !== null &&
        hook.deviceArea.number !== null
      }
      animationDuration={150}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          alt="ic"
        />
      }
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h2>ID:{hook.auth.user_token_id}</h2>
            <button className="settingButton" onClick={hook.navigateSettings}>
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_setting.svg`}
                alt="setting"
              />
            </button>
          </div>
          <div className="modal_content">
            <h2 className="title">기기 설정</h2>
            <div className="deviceWrap">
              <div className="settingWrap">
                <div className="settingItem">
                  <h3>상시 전원 여부</h3>
                  <div className="toggleWrap">
                    <button
                      className={`toggleItem ${
                        hook.devicePower === 0 && "active"
                      }`}
                      onClick={() => hook.setDevicePower(0)}
                    >
                      비상시
                    </button>
                    <button
                      className={`toggleItem ${
                        hook.devicePower === 1 && "active"
                      }`}
                      onClick={() => hook.setDevicePower(1)}
                    >
                      상시
                    </button>
                  </div>
                </div>
                <div className="settingItem">
                  <h3>상시 WIFI 여부</h3>
                  <div className="toggleWrap">
                    <button
                      className={`toggleItem ${
                        hook.deviceWifiPower === 0 && "active"
                      }`}
                      onClick={() => hook.setDeviceWifiPower(0)}
                    >
                      비상시
                    </button>
                    <button
                      className={`toggleItem ${
                        hook.deviceWifiPower === 1 && "active"
                      }`}
                      onClick={() => hook.setDeviceWifiPower(1)}
                    >
                      상시
                    </button>
                  </div>
                </div>
              </div>
              <h3>기기 특이사항 메모</h3>
              <input
                value={hook.deviceMemo}
                onChange={(e) => hook.setDeviceMemo(e.target.value)}
                placeholder="기기 특이사항을 입력하세요"
              />
            </div>
            <button
              className="submitButton save"
              onClick={hook.setUserTokenInfo}
            >
              기기 설정 저장
            </button>
            <h2 className="title">객실 설정</h2>
            <div className="listWrap">
              <div className="sideListWrap">
                {hook.areaList.map((item: AreaType, index: number) => {
                  return (
                    <div className="selectedButton" key={index}>
                      <h2
                        className={`${
                          hook.selectedArea === item.area_number &&
                          "activeFloor"
                        }`}
                        key={index}
                        onClick={() => hook.onChangeArea(item)}
                      >
                        {item.area_name}
                      </h2>
                    </div>
                  );
                })}
              </div>
              <div className="sideListWrap">
                {hook.roomList &&
                  hook.roomList.room_list.map(
                    (item: RoomType, index: number) => {
                      return (
                        <div
                          className={`selectedButton ${
                            hook.selectedRoom === item.number && "activeArea"
                          }`}
                          key={index}
                        >
                          <h2
                            key={index}
                            onClick={() => hook.setSelectedRoom(item.number)}
                          >
                            {item.name}
                          </h2>
                        </div>
                      );
                    }
                  )}
              </div>
            </div>
            <button
              className="submitButton save"
              onClick={() => hook.setArea()}
            >
              객실 설정 저장
            </button>
          </div>
          <div className="modal_footer">
            <div className="row">
              <button
                className="submitButton cancel"
                onClick={() => hook.sendPostMsgToApp("logout")}
              >
                로그아웃
              </button>
              <button
                className="submitButton cancel"
                onClick={() => hook.sendPostMsgToApp("restartApp")}
              >
                앱 다시시작
              </button>
              <button
                className="submitButton off"
                onClick={() => hook.sendPostMsgToApp("offApp")}
              >
                앱 종료
              </button>
            </div>
            <div className="row">
              <button
                className="submitButton cancel"
                onClick={() => hook.sendPostMsgToApp("reboot")}
              >
                기기 다시시작
              </button>
              <button
                className="submitButton cancel"
                onClick={() => hook.sendPostMsgToApp("shutdown")}
              >
                기기 종료
              </button>
            </div>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default SelectAreaModalView;
